export default __webpack_public_path__ + "static/media/screen_google_calendar_08.21350708.png";